import produce from 'immer';
import { CSV_DATA_MANAGEMENT_ACTIONS } from './actions';

const initialState = {
  records: [],
  loading: false,
  type: '',
};

const CSVDataManagement = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CSV_DATA_MANAGEMENT_ACTIONS.GET_CSV_LOGGERS:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = type;
      });
    case CSV_DATA_MANAGEMENT_ACTIONS.GET_CSV_LOGGERS_SUCCESS:
      return produce(state, (draft) => {
        draft.records = payload;
        draft.loading = false;
        draft.type = type;
      });
    case CSV_DATA_MANAGEMENT_ACTIONS.GET_CSV_LOGGERS_ERROR:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = type;
      });
    case CSV_DATA_MANAGEMENT_ACTIONS.DOWNLOAD_CSV_DATA:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = type;
      });
    case CSV_DATA_MANAGEMENT_ACTIONS.DOWNLOAD_CSV_DATA_SUCCESS:
    case CSV_DATA_MANAGEMENT_ACTIONS.DOWNLOAD_CSV_DATA_ERROR:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = type;
      });
    default:
      return state;
  }
};

export default CSVDataManagement;
